import { Injectable } from '@angular/core';
import { Platform } from '@ionic/angular';
import { Router } from '@angular/router';
import { PlatformService } from './platform.service';

@Injectable({
  providedIn: 'root',
})
export class RoutingService {
  constructor(private platformService: PlatformService, private router: Router) {}

  public initRouting() {
    if (this.platformService.isMobilePlatform()) {
      this.router.resetConfig([{ path: '', loadChildren: () => import('../mobile-routing.module').then(m => m.MobileRoutingModule) }]);
    } else {
      this.router.resetConfig([{ path: '', loadChildren: () => import('../app-routing.module').then(m => m.AppRoutingModule) }]);
    }
  }
}
